import styled from "styled-components";
import tw from "tailwind.macro";

const Container = styled.div.attrs(({ className }) => ({
  className: `container h-full relative ${className || ""}`,
}))`
  ${({ noPadding }) => noPadding && tw`px-0`}
`;

export default Container;
